var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-layout d-flex flex-column",attrs:{"id":"app"}},[(!_vm.showDetail)?_c('mobile-header'):_c('detail-header',{attrs:{"content":_vm.content}}),_c('mobile-container',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }